import { validates } from '../utils/ValidateFormObject'

const consultaRapidaERecomendacoes = {
  tipo: {
    required: true
  },
  descricao: {
    required: false
  },
  document: {
    conditionalRequired(obj) {
      const errorMessage = 'É obrigatório o upload de um arquivo HTML.'
      if (!obj['conteudoHtml']) {
        return {
          required: true,
          errorMessage
        }
      } else {
        return {
          required: false,
          errorMessage
        }
      }
    }
  },
  titulo: {
    required: true
  },
  autores: {
    required: true
  },
  editores: {
    required: false
  },
  especialidades: {
    required: true
  },
  pesoDA: {
    required: true
  },
  idioma: {
    required: true
  },
  palavrasChave: {
    required: true
  },
  codigo: {
    required: true,
    func: validates.codigoArtigoDiretriz,
    errorMessage: 'Este campo deve conter um número de código de artigo válido.'
  },
  anoPublicacao: {
    required: true,
    func: validates.copyright,
    errorMessage: 'Este campo deve conter 4 dígitos numéricos.'
  },
  dataAtualizacao: {
    required: true,
    func: validates.date,
    errorMessage: 'Este campo deve conter uma data válida.'
  },
  codigoProtheus: {
    required: true,
    func: validates.isbn,
    errorMessage: 'Este campo deve conter um número de ISBN válido.'
  },
  isbn: {
    required: false,
    func: validates.isbn,
    errorMessage: 'Este campo deve conter um número de ISBN válido.'
  },
  issn: {
    required: false,
    func: validates.issn,
    errorMessage: 'Este campo deve conter um número de ISSN válido.'
  }
}

export default consultaRapidaERecomendacoes



// WEBPACK FOOTER //
// ./src/contentSchema/diagnosticoETratamento.js